// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchTabs__wrapper___2RDoW","tabsWrapper":"SearchTabs__tabsWrapper___2QwpR"};